import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

async function startApp() {
  // Load runtime configuration
  try {
    const response = await fetch('/config.json');
    if (response.ok) {
      window.APP_CONFIG = await response.json();
    } else {
      console.warn('config.json not found, using environment variables');
    }
  } catch (error) {
    console.error('Failed to load runtime configuration:', error);
  }

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

startApp();
